import { getCountData } from './service';
// import { isLoading } from '../../../constants/actionConstants';
export const FETCH_COUNT_REQUEST = "FETCH_COUNT_REQUEST";
export const FETCH_COUNT_SUCCESS = "FETCH_COUNT_SUCCESS";
export const FETCH_COUNT_FAILURE = "FETCH_COUNT_FAILURE";

export const fetchCountRequest = () => ({
    type: FETCH_COUNT_REQUEST,
});

export const fetchCountSuccess = (data) => ({
    type: FETCH_COUNT_SUCCESS,
    payload: data,
});

export const fetchCountFailure = (error) => ({
    type: FETCH_COUNT_FAILURE,
    payload: error,
});

export const fetchCountData = () => async (dispatch) => {
    dispatch(fetchCountRequest());
    try {
        const data = await getCountData();
        dispatch(fetchCountSuccess(data));
        return data;
    } catch (error) {
        dispatch(fetchCountFailure(error.message));
    }
};